exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".banned-user{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.banned-user-wrapper{border-bottom:1px dashed #dcdcdc;padding-bottom:.3em;margin-bottom:.3em}.banned-user a{color:#333}.banned-user img{width:25px;height:auto;border-radius:50%;margin-right:.2em}.banned-user-description{background:#fdfdfd;color:#333;border:1px solid #e7e7e7;padding:.5em;border-radius:2px;line-height:2;overflow:auto;margin:.3em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4372ba82","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/BannedUser.vue
// module id = 9snK
// module chunks = 0